import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-email-jpg-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfEmailJpgIconProps extends SvgIconProps {}

/**
 * CcfEmailJpgIcon used to disply jpg icon in the email attachment
 * @param props - CcfEmailJpgIconProps
 * @example -- <CcfEmailJpgIcon />
 * **/
export function CcfEmailJpgIcon(props: CcfEmailJpgIconProps) {
  return (
    <SvgIcon
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      {...props}
    >
      <path
        d="M9.77004 0H1.00847C0.776652 0.00105367 0.554657 0.0891859 0.390831 0.245204C0.227005 0.401223 0.134618 0.61249 0.133789 0.833L0.133789 9.167C0.134618 9.38751 0.227005 9.59878 0.390831 9.7548C0.554657 9.91081 0.776652 9.99895 1.00847 10H9.77004C10.0022 9.99947 10.2248 9.91157 10.389 9.7555C10.5533 9.59942 10.646 9.38785 10.6468 9.167V0.833C10.646 0.612145 10.5533 0.400577 10.389 0.244502C10.2248 0.0884267 10.0022 0.000526944 9.77004 0V0ZM9.77004 0.833V8.417L7.84195 6.042C7.77985 5.92761 7.68549 5.83193 7.56943 5.7657C7.45337 5.69946 7.32021 5.66528 7.18488 5.667C6.91513 5.68813 6.66434 5.8074 6.48471 6L6.00322 6.5L3.68089 4.375C3.61872 4.27297 3.52926 4.18842 3.42161 4.12993C3.31396 4.07144 3.19195 4.04111 3.06798 4.042C2.79785 4.06288 2.54664 4.18218 2.36676 4.375L1.00847 5.667V0.833H9.77004ZM9.28854 9.167H4.46937L7.14178 6.542L9.28749 9.167H9.28854ZM1.00953 6.875L3.02487 4.875L5.39031 7.083L3.24355 9.167H1.00953V6.875Z"
        fill="#006398"
      />
    </SvgIcon>
  );
}

export default CcfEmailJpgIcon;
